<template>
  <div>
    <editor :apiKey="apiKey" :init="innit" :value="model" @input="setModelData">
    </editor>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
export default {
  components: { Editor },
  name: "InputEditor",
  props: {
    model: "",
    id: ""
  },
  created() {},

  data() {
    return {
      apiKey: "dfsjfrd4yl1bw0v8157tap75tn6oo94azgqeemqtv3o2cayk",
      innit: {
        height: 500,
        menubar: "edit view insert format tools table",
        plugins:
          "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
        toolbar:
          "undo redo | bold italic underline strikethrough | forecolor backcolor\
          alignleft aligncenter alignright alignjustify | \
          fontselect fontsizeselect formatselect |\
          outdent indent |  numlist bullist checklist |\
          casechange permanentpen formatpainter removeformat |\
          pagebreak | fullscreen  preview save print |\
          insertfile image media pageembed link anchor |\
          a11ycheck ltr rtl | showcomments addcomment"
      }
    };
  },
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
.toolbar {
  background-color: white;
  /*border-radius: 30px;*/
}
</style>
